import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import "./ManageHologram.css";
import Axios from "axios";
import Table from "react-bootstrap/Table";

const ManageHologram = () => {
  const [data, setData] = useState([]);
  const [yearlyData, setYearlyData] = useState({});
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [allData, setAllData] = useState({
    totalQuantity: 0,
    totalUsed: 0,
    totalDamaged: 0,
  });

  const toCount = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  };

  const formatCount = (value) => toCount(value).toLocaleString("en-IN");

  const formatOptionalCount = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    const number = Number(value);
    return Number.isFinite(number) ? number.toLocaleString("en-IN") : "—";
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(INVENTORY_API_BASE_URL + "/getHologram").then((response) => {
      const reversedData = response.data.reverse();
      setData(reversedData);
      const yearlyStats = {};
      reversedData.forEach((row) => {
        const rowDate = new Date(row.Date);
        const year =
          rowDate.getMonth() >= 3
            ? rowDate.getFullYear() + 1
            : rowDate.getFullYear();
        if (!yearlyStats[year]) {
          yearlyStats[year] = {
            totalQuantity: 0,
            totalUsed: 0,
            totalDamaged: 0,
          };
        }
        yearlyStats[year].totalQuantity += toCount(row.Quantity);
        yearlyStats[year].totalUsed += toCount(row.used);
        yearlyStats[year].totalDamaged += toCount(row.damaged);
      });
      setYearlyData(yearlyStats);
    });
  }, []);

  useEffect(() => {
    const allYearsData = {
      totalQuantity: 0,
      totalUsed: 0,
      totalDamaged: 0,
    };

    for (const year in yearlyData) {
      allYearsData.totalQuantity += yearlyData[year].totalQuantity;
      allYearsData.totalUsed += yearlyData[year].totalUsed;
      allYearsData.totalDamaged += yearlyData[year].totalDamaged;
    }

    setAllData(allYearsData);
  }, [yearlyData]);

  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    years.push(
      <option key="all" value="all">
        All
      </option>
    );

    const uniqueYears = new Set();
    for (let year in yearlyData) {
      uniqueYears.add(year);
    }
    uniqueYears.add((currentYear + 1).toString());
    uniqueYears.forEach((year) => {
      years.push(
        <option key={year} value={year}>
          FY-{parseInt(year) - 1}-{year}
        </option>
      );
    });
    return years;
  };

  const handleYearChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedYear(selectedValue === "all" ? "all" : parseInt(selectedValue));
  };

  const summaryData =
    selectedYear === "all"
      ? allData
      : yearlyData[selectedYear] || {
          totalQuantity: 0,
          totalUsed: 0,
          totalDamaged: 0,
        };
  const selectedPeriod =
    selectedYear === "all"
      ? "All fiscal years"
      : "FY-" + (parseInt(selectedYear) - 1) + "-" + selectedYear;

  return (
    <main className="manage-hologram-page">
      <div className="manage-hologram-workspace">
        <header className="manage-hologram-hero">
          <div className="manage-hologram-hero-copy">
            <p className="manage-hologram-eyebrow">Inventory / Security labels</p>
            <h1>Hologram status</h1>
            <p>
              Track dispatched holograms, usage, and damaged or returned stock
              across fiscal years.
            </p>
          </div>
          <div className="manage-hologram-hero-badge">
            <span className="manage-hologram-hero-icon" aria-hidden="true">H</span>
            <span>
              <strong>Hologram overview</strong>
              <small>{selectedPeriod}</small>
            </span>
          </div>
        </header>

        <section
          className="manage-hologram-summary"
          aria-labelledby="manage-hologram-summary-title"
        >
          <header className="manage-hologram-summary-heading">
            <div>
              <p className="manage-hologram-section-eyebrow">Reporting period</p>
              <h2 id="manage-hologram-summary-title">Hologram overview</h2>
              <p>Choose a fiscal year to update these totals. The register below shows all records.</p>
            </div>
            <div className="manage-hologram-year-control">
              <label htmlFor="yearSelector">Fiscal year</label>
              <select
                id="yearSelector"
                name="yearSelector"
                onChange={handleYearChange}
                value={selectedYear}
              >
                {getYearOptions()}
              </select>
            </div>
          </header>

          <div className="manage-hologram-metrics">
            <article className="manage-hologram-metric">
              <span className="manage-hologram-metric-icon" aria-hidden="true">OUT</span>
              <div>
                <span className="manage-hologram-metric-label">YTD dispatched by Pinnacle</span>
                <strong>{formatCount(summaryData.totalQuantity)}</strong>
              </div>
            </article>
            <article className="manage-hologram-metric manage-hologram-metric-used">
              <span className="manage-hologram-metric-icon" aria-hidden="true">USE</span>
              <div>
                <span className="manage-hologram-metric-label">Used by Shivalik</span>
                <strong>{formatCount(summaryData.totalUsed)}</strong>
              </div>
            </article>
            <article className="manage-hologram-metric manage-hologram-metric-damaged">
              <span className="manage-hologram-metric-icon" aria-hidden="true">DMG</span>
              <div>
                <span className="manage-hologram-metric-label">Damaged / destroyed / sent back</span>
                <strong>{formatCount(summaryData.totalDamaged)}</strong>
              </div>
            </article>
          </div>
        </section>

        <section
          className="manage-hologram-register"
          aria-labelledby="manage-hologram-register-title"
        >
          <header className="manage-hologram-register-heading">
            <div>
              <p className="manage-hologram-section-eyebrow">Dispatch register</p>
              <h2 id="manage-hologram-register-title">Hologram records</h2>
              <p>Serial ranges and quantities for all hologram dispatches.</p>
            </div>
            <span className="manage-hologram-record-count">
              {data.length.toLocaleString("en-IN")}{" "}
              {data.length === 1 ? "RECORD" : "RECORDS"}
            </span>
          </header>

          {data.length > 0 ? (
            <div className="manage-hologram-table-shell">
              <Table className="manage-hologram-table">
                <thead>
                  <tr>
                    <th scope="col">Dispatched date</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Serial number range</th>
                    <th scope="col">Used</th>
                    <th scope="col">Damaged</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row) => (
                    <tr key={row.orderno}>
                      <td data-label="Dispatched date">
                        {formatDate(row.Date)}
                      </td>
                      <td data-label="Quantity">
                        <span className="manage-hologram-quantity">{formatOptionalCount(row.Quantity)}</span>
                      </td>
                      <td data-label="Serial number range">
                        <span className="manage-hologram-range">
                          {row.StartingNo}-{row.EndingNo}
                        </span>
                      </td>
                      <td data-label="Used">{formatOptionalCount(row.used)}</td>
                      <td data-label="Damaged">{formatOptionalCount(row.damaged)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="manage-hologram-empty-state">
              <span className="manage-hologram-empty-icon" aria-hidden="true">H</span>
              <strong>No hologram records to display</strong>
              <span>Dispatch records will appear here when they are available.</span>
            </div>
          )}

          {data.length > 0 && (
            <footer className="manage-hologram-footer">
              Showing all {data.length.toLocaleString("en-IN")}{" "}
              {data.length === 1 ? "record" : "records"}
            </footer>
          )}
        </section>
      </div>
    </main>
  );
};

export default ManageHologram;
